import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderAddLeft"><Path d="M2.5 11.5V3.5H10L12 6.5H21.5V19.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 14.5V17.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 17.5H4.5H7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderAddLeft;
